var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 29,
    viewBox: "0 0 19 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24444 11.9407L8.30358 13.9C9.47001 16.0577 11.7518 17.3751 14.2037 17.3064L16.43 17.244L14.4708 18.3031C12.313 19.4696 10.9956 21.7513 11.0643 24.2032L11.1267 26.4296L10.0676 24.4703C8.90116 22.3125 6.61938 20.9952 4.16749 21.0639L1.94114 21.1263L3.90041 20.0671C6.05818 18.9007 7.37556 16.6189 7.30684 14.167L7.24444 11.9407Z",
    fill: "#FD830C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7083 1.26185L11.7308 1.30347C12.8972 3.46123 15.179 4.77861 17.6309 4.7099L17.6782 4.70857L17.6366 4.73107C15.4788 5.8975 14.1614 8.17928 14.2302 10.6312L14.2315 10.6785L14.209 10.6368C13.0425 8.47908 10.7608 7.1617 8.30887 7.23042L8.26159 7.23174L8.3032 7.20925C10.461 6.04281 11.7783 3.76104 11.7096 1.30914L11.7083 1.26185Z",
    fill: "#FD830C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarGroup);
export default __webpack_public_path__ + "static/media/Star_group.3ddfb031266fc9a43f5170b2404d97cc.svg";
export { ForwardRef as ReactComponent };